import { AppBar, Box, Tab, Tabs } from "@mui/material";
import { ConnectionType } from "protico-sdk";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
type Prop = {
  children: React.ReactNode;
  setModalType: React.Dispatch<React.SetStateAction<ConnectionType>>;
  modalType: ConnectionType;
};
const FriendPageLayout: React.FC<Prop> = ({
  children,
  setModalType,
  modalType,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <div className="friend-container">
        <AppBar position="static">
          <Tabs
            value={modalType}
            onChange={(e, value) => setModalType(value)}
            variant="fullWidth"
          >
            <Tab
              label={t("SocialConnection_Friend_List")}
              value={ConnectionType.CONNECT}
              sx={{ textTransform: "none", fontSize: "13px" }}
            />
            <Tab
              label={t("SocialConnection_Block_List")}
              value={ConnectionType.BLOCK}
              sx={{ textTransform: "none", fontSize: "13px" }}
            />
          </Tabs>
        </AppBar>
        <div className="friend-list-container">{children}</div>
      </div>
    </Box>
  );
};
export default FriendPageLayout;
